import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-warm-grey/30 bg-off-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img src="/logo.png" alt="YONO" className="h-8 w-auto" />
            <p className="font-body text-sm text-soft-black/70 leading-relaxed max-w-xs">
              Habitats bois contemporains.<br />Sobres. Chaleureux. Durables.
            </p>
          </div>
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-warm-grey">Navigation</span>
            <nav className="flex flex-col gap-3 mt-4">
              <Link to="/produits" data-testid="footer-produit" className="font-body text-sm text-soft-black/70 hover:text-soft-black transition-colors">Produits</Link>
              <Link to="/about" data-testid="footer-about" className="font-body text-sm text-soft-black/70 hover:text-soft-black transition-colors">À propos</Link>
              <Link to="/faq" data-testid="footer-faq" className="font-body text-sm text-soft-black/70 hover:text-soft-black transition-colors">FAQ</Link>
              <Link to="/contact" data-testid="footer-contact" className="font-body text-sm text-soft-black/70 hover:text-soft-black transition-colors">Contact</Link>
              <Link to="/mentions-legales" data-testid="footer-mentions" className="font-body text-sm text-soft-black/70 hover:text-soft-black transition-colors">Mentions légales</Link>
            </nav>
          </div>
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-warm-grey">Contact</span>
            <div className="flex flex-col gap-3 mt-4">
              <span className="font-body text-sm text-soft-black/70">contact@yono-studio.com</span>
              <span className="font-body text-sm text-soft-black/70">+33 (0)6 83 58 18 04</span>
            </div>
          </div>
        </div>
        <div className="border-t border-warm-grey/30 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <span className="font-mono text-xs text-warm-grey">&copy; {new Date().getFullYear()} YONO. Tous droits reserv&eacute;s.</span>
          <span className="font-mono text-xs text-warm-grey">Habitats bois premium</span>
        </div>
      </div>
    </footer>
  );
}
